import { render } from "./WatchMyVideo.vue?vue&type=template&id=b388ac0a&scoped=true"
import script from "./WatchMyVideo.vue?vue&type=script&lang=js"
export * from "./WatchMyVideo.vue?vue&type=script&lang=js"

import "./WatchMyVideo.vue?vue&type=style&index=0&id=b388ac0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b388ac0a"]])

export default __exports__